module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('PasswordRecovery', {
		sendRecoveryMail: function(email, useProdDomain) {
			var api = this.getApi('recovery', {
				method: this.getOption('recoveryMethod') || 'passwordRecovery.sendRecoveryMail'
			});

			this.handleEvent(api, ['success', 'failure', 'error'], fox.bind(function(data) {
				this.dispatchEvent('sendRecoveryMail', data.answer.response);
			}, this));

			var obj = {email: email};

			if (useProdDomain) {
				obj = {email: email, domainProd: 1};
			}

			api.send(obj, false);
		},
		
		validateHash: function(hash) {
			var api = this.getApi('validate', {
				method: this.getOption('validateMethod') || 'passwordRecovery.validateHash'
			});

			this.handleEvent(api, ['success', 'error'], fox.bind(function(data) {
				this.dispatchEvent('validateHash', data.answer.response);
			}, this));

			api.send({hash: hash}, false);	
		},

		changePassword: function(hash, password, confirm) {
			var api = this.getApi('change', {
				method: this.getOption('changeMethod') || 'passwordRecovery.changePassword'
			});

			this.handleEvent(api, ['success'], fox.bind(function(data) {
				this.dispatchEvent('changePassword', data.answer.response);
			}, this));

			api.send({hash: hash, password: password, confirm: confirm}, false);
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/passwordRecovery.js
// module id = 219
// module chunks = 0